import { Mixins, Component } from "vue-property-decorator";
import UserMixin from "@/mixins/userMixin";

@Component
export default class AuthMixin extends Mixins(UserMixin) {
  /** 解約・停止権限の有無 */
  public get IsCancellationAuthorized(): boolean {
    // ルーティング情報に設定されている権限パス名取得
    const authPathName = this.$router.currentRoute.meta?.authName as string;
    if (!authPathName) {
      return false;
    }

    // ログインユーザーの権限情報から設定されている権限を取得
    const targetAuthFunction = this.User.admin_auth.admin_auth_functions.find(
      (af) => af.function.path == authPathName
    );
    if (!targetAuthFunction) {
      return false;
    }

    const authKeySet = new Set(
      targetAuthFunction.editing_auths.flatMap((ea) =>
        ea.allowed ? ea.key : []
      )
    );

    const authKeys = ["is_edit", "cancellation"];

    return authKeys.every((key) => authKeySet.has(key));
  }
}
